import React from 'react';
import './AlertComponent.css';

const AlertComponent = ({ show, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div className="alert-overlay">
      <div className="alert-modal">
        <h2>Confirm Removal</h2>
        <p>Are you sure you want to remove this ?</p>
        <div className="alert-buttons">
          <button onClick={onConfirm} className="alert-button confirm">Yes</button>
          <button onClick={onCancel} className="alert-button cancel">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AlertComponent;